import React, { FC, RefObject, useState } from 'react';
import LightningBolt from 'assets/svg/bolt.svg';
import ErrorIcon from 'assets/svg/error.svg';
import WarningIcon from 'assets/svg/warning.svg';
import classnames from 'classnames';
import { domAnimation, LazyMotion, m } from 'framer-motion';

import s from './Notification.module.scss';

const c = classnames.bind(s);

type NotificationProps = {
  title?: string;
  type: 'success' | 'warning' | 'error';
  onClose?: () => void;
  notificationRef?: RefObject<HTMLDivElement>;
  children?: React.ReactNode;
};

const alertVariation = {
  hidden: {
    opacity: 0,
    x: 20,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: { type: 'spring' },
  },
};

export type NotificationMessage = {
  title?: string;
  message: string;
  type?: 'success' | 'warning' | 'error';
};

const Notification: FC<NotificationProps> = ({
  type,
  onClose,
  title,
  notificationRef,
  children,
}) => {
  const [closing, setClosing] = useState(false);
  const closeNotification = () => {
    setClosing(true);
    onClose && onClose();
  };

  return (
    <LazyMotion features={domAnimation}>
      <m.div
        ref={notificationRef}
        className={s.notification}
        initial={type === 'error' ? 'hidden' : 'visible'}
        animate={type === 'error' && 'visible'}
        variants={alertVariation}
      >
        <div
          className={c(s.notification__icon, {
            [s.success]: type === 'success',
            [s.warning]: type === 'warning',
            [s.error]: type === 'error',
          })}
        >
          {type === 'warning' ? (
            <WarningIcon />
          ) : type === 'error' ? (
            <ErrorIcon />
          ) : (
            <LightningBolt />
          )}
        </div>
        <div className={s.notification__text}>
          {title && <strong className={s.notification__title}>{title}</strong>}
          {children}
        </div>
        {onClose && (
          <button
            className={s.notification__close}
            type="button"
            onClick={closeNotification}
          >
            <div className={s.notification__closeIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 11">
                <path
                  fill="currentColor"
                  d="M6.707 5.375l3.156 3.156a.468.468 0 010 .661l-.733.733a.468.468 0 01-.662 0L5.312 6.77 2.157 9.926a.468.468 0 01-.662 0l-.733-.734a.468.468 0 010-.661l3.156-3.156L.762 2.219a.468.468 0 010-.661l.733-.733a.468.468 0 01.662 0L5.312 3.98 8.468.824a.468.468 0 01.662 0l.733.734a.468.468 0 010 .661L6.707 5.375z"
                />
              </svg>
            </div>
            Loka
          </button>
        )}
      </m.div>
    </LazyMotion>
  );
};

export default Notification;
